import * as React from 'react';
export var MenuContext = React.createContext({});
export var useMenuContext = function useMenuContext() {
  return React.useContext(MenuContext);
};